
import { toast } from "react-toastify";
import { cancelZohoSubscription } from "../service/ZohoPlanService";

export function getGST(value, percent = 18) {
  return (value * percent) / 100;
}

export const handleCancelSubscription = async (
  subscriptionId,
  cb = () => {}
) => {
  try {
    const data = await cancelZohoSubscription(subscriptionId);
    if (data?.message) {
      toast.success(data?.message);
      cb();
    }
    console.log(data, "data cancelled");
  } catch (error) {
    toast.error(error?.message);
  }
};
